import { X } from "lucide-react";
import { Reveal, Label } from "./Motion";

const notList = [
  "A traditional accounting firm",
  "A marketing agency",
  "A generic management consultant",
  "A software company",
  "A replacement for your leadership team",
];

export default function Positioning() {
  return (
    <section id="positioning" data-testid="positioning-section" className="relative py-28 lg:py-40 bg-[#f4f1e8]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <Label>What Elevare isn&apos;t</Label>
          <h2 className="mt-6 font-head text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-[#1e3d3a]">
            Not What You&apos;ve<br />
            <span className="text-black/40">Hired Before.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* We are not */}
          <Reveal className="lg:col-span-6">
            <div className="h-full rounded-2xl border border-black/10 bg-white/60 p-8 lg:p-10">
              <p className="text-[10px] uppercase tracking-[0.28em] text-[#8a5c3a] font-medium">We are not</p>
              <ul className="mt-8 space-y-4">
                {notList.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-base leading-relaxed text-black/60">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-black/15">
                      <X className="h-3 w-3 text-black/40" strokeWidth={2.5} />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* What we are */}
          <Reveal className="lg:col-span-6" delay={0.1}>
            <div className="h-full rounded-2xl border border-[#1e3d3a]/15 bg-[#1e3d3a] p-8 lg:p-10 flex flex-col justify-center">
              <p className="text-[10px] uppercase tracking-[0.28em] text-[#c9a961] font-medium">What we are</p>
              <p className="mt-6 font-head text-2xl lg:text-3xl leading-snug text-white">
                A business intelligence and improvement partner that helps leadership
                <span className="text-[#c9a961]"> understand the business</span>, make better
                decisions, and execute meaningful improvements.
              </p>
            </div>
          </Reveal>
        </div>

        {/* Differentiator */}
        <Reveal className="mt-24 lg:mt-32">
          <div className="max-w-4xl">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#a3823f] font-medium">The difference</p>
            <h3 className="mt-6 font-head text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[1.02] text-[#1e3d3a]">
              We Don&apos;t Just Give You<br />
              <span className="text-[#a3823f]">Recommendations.</span>
            </h3>
            <p className="mt-8 max-w-2xl text-lg lg:text-xl leading-relaxed text-black/70">
              We help you understand the problem, determine what matters most, build the strategy,
              and execute the improvement.
            </p>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-black/45">
              That&apos;s what separates Elevare from consultants who simply deliver a PowerPoint and leave.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
